/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "google": {
    "nested": {
      "protobuf": {
        "nested": {
          "Empty": {
            "fields": {}
          }
        }
      }
    }
  }
});

/**
 * A generic empty message that you can re-use to avoid defining duplicated
 * empty messages in your APIs. A typical example is to use it as the request
 * or the response type of an API method. For instance:
 *
 *     service Foo {
 *       rpc Bar(google.protobuf.Empty) returns (google.protobuf.Empty);
 *     }
 *
 *
 * SOURCE Empty @ google/protobuf/empty.proto at 51:1
 */
export const Empty = $root.lookupType('google.protobuf.Empty');
fixType(Empty);
Builder.createAndAttachToType(Empty);
